import { render, staticRenderFns } from "./HelpRenderer.vue?vue&type=template&id=acfcfe00&"
import script from "./HelpRenderer.vue?vue&type=script&lang=js&"
export * from "./HelpRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports